module.exports = __webpack_public_path__ + "static/media/mf.308936fb.svg";